import { Form } from "react-bootstrap";

// The same view choice in search and the PCO Dashboard. This only changes
// the job-list column, never which claims or report counts are returned.
export default function AttentionColumnOptions({ noteColumn, onChange, idPrefix }) {
  return (
    <>
      <div className="small fw-semibold mb-1">Attention column</div>
      <div className="small text-muted mb-2">What the results show beside each job.</div>
      {[
        [false, "Needs Attention badges", "What each job is waiting on (the default)"],
        [true, "RDR note (editable)", "The running note, as on Workflow Management"],
      ].map(([value, label, hint]) => (
        <Form.Check key={String(value)} type="radio"
          name={`${idPrefix}-attention-column`} id={`${idPrefix}-attention-col-${value}`}
          className="small" checked={noteColumn === value} onChange={() => onChange(value)}
          label={<>{label}<span className="d-block text-muted" style={{ fontSize: "0.75rem" }}>{hint}</span></>} />
      ))}
    </>
  );
}
